import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    pdfItemView: {
      zIndex: theme.zIndex.max,
      height: "100%",
      width: "100%",
      position: "absolute",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    mainContainer: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
    },
  },
  web: {
    pdfItemView: {
      zIndex: theme.zIndex.max,
      height: "100%",
      width: "100%",
      position: "absolute",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    mainContainer: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
    },
  },
});
